/**
 * src/store/authStore.js
 * Store de autenticación v3: login por usuario/contraseña → JWT corto (Bearer).
 * El token maestro estático (ADMIN_TOKEN) ya NO vive en el navegador.
 * Persiste en sessionStorage (se borra al cerrar la pestaña; no es un secreto
 * permanente, es un JWT de corta duración).
 */
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,          // JWT de sesión (Bearer), de corta duración
      isAuthenticated: false,
      user: null,           // { email, nombre, rol, tier }
      isAdmin: false,       // true cuando el usuario tiene rol 'admin'

      // Auth con JWT (login usuario/contraseña)
      setJwt: (token, user) => set({
        token,
        isAuthenticated: true,
        user,
        isAdmin: user?.rol === 'admin',
      }),

      updateUser: (user) => set({ user }),

      // Reemplaza solo el JWT conservando la sesión (p.ej. tras cambiar la
      // contraseña, que reemite un token nuevo con el token_version actualizado).
      setToken: (token) => set({ token }),

      logout: () => set({
        token: null,
        isAuthenticated: false,
        user: null,
        isAdmin: false,
      }),

      getToken: () => get().token,
    }),
    {
      name: 'cm-monitor-auth',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        isAdmin: state.isAdmin,
      }),
    }
  )
)
